import { axios } from "@/lib/axios";
import {
  IAPIGetMuqabalaPrices,
  IAPIPostMuqabalaPrice,
  IAPIPatchMuqabalaPrice,
  IAPIDeleteMuqabalaPrice,
} from "../../types/interfaces/api/muqabalaPrices";
import { TMuqabalaPriceInitialValues } from "../../containers/Settings/MuqabalaPrices/MuqabalaPrices.container";

export const getMuqabalaPrices = (): Promise<IAPIGetMuqabalaPrices> => {
  return axios.get("/muqabala/muqabala-prices", {
    params: {
      is_active: true,
    },
  });
};

export const createMuqabalaPrice = (
  datas: TMuqabalaPriceInitialValues
): Promise<IAPIPostMuqabalaPrice> => {
  return axios.post("/muqabala/muqabala-prices", {
    ...datas,
  });
};

export const editMuqabalaPrice = (
  id: string,
  datas: Partial<TMuqabalaPriceInitialValues>
): Promise<IAPIPatchMuqabalaPrice> => {
  return axios.patch(`/muqabala/muqabala-prices/${id}`, {
    ...datas,
  });
};

export const deleteMuqabalaPrice = (
  id: string
): Promise<IAPIDeleteMuqabalaPrice> => {
  return axios.delete(`/muqabala/muqabala-prices/${id}`);
};
